<template>
  <div id="app">
    <transition name="slide-fade">
      <router-view/>
    </transition>
    <user-banned-modal-handler/>
    <ModalWelcome :show="newRegister" @cancel="cancelHandler" />

    <iframe
        v-if="loadIFrame"
        width="0"
        height="0"
        :src="IFrameURL"
        frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import UserBannedModalHandler from "./components/UserBannedModalHandler";
import ModalWelcome from "./components/Modal/Welcome";
import eventbus from "./eventbus";
import { Handler as WebstarAuthHandler } from './modules/WebstarAuth/Handler'
import ThemeManager from "./modules/ThemeManager/ThemeManager";

export default {
  name: "app",
  components: {
    UserBannedModalHandler,
    ModalWelcome
  },
  data() {
    return {
      newRegister: false,
      loadIFrame: false,
      IFrameURL: ""
    };
  },
  methods: {
    cancelHandler() {
      this.newRegister = false;
    },
    newRegisterHandler() {
      this.newRegister = true;
    },
    loadSiteType() {
      const urlParams = new URLSearchParams(window.location.search);
      let siteType = urlParams.get('site_type');
      ThemeManager.setTheme(siteType);
    }
  },
  mounted() {
    eventbus.handleNewRegister(this.newRegisterHandler);
    WebstarAuthHandler.IFrameLoadCB = (data) => {
      this.loadIFrame = true;
      this.IFrameURL = data;
    };
    
    window.addEventListener('message', (message) => {
      try {
        if (typeof message.data !== 'string') return;
        const data = JSON.parse(message.data);
        
        if (message.origin !== process.env.VUE_APP_WEBSTARS_PANEL_URL) return;

        if (data.login) {
          WebstarAuthHandler.isReady = true;
          WebstarAuthHandler.isModelLoggedInIframeCallback();
          //WebstarAuthHandler.clearIframeLoadData();
        }
      } catch (error) {
        console.log(error);
      }
    });

    this.loadSiteType();
  },
  beforeDestroy() {
    eventbus.destroyNewRegisterHandler(this.newRegisterHandler);
  },
  watch: {
    $route (to, from) {
      if (to.query.site_type && to.query.site_type !== ThemeManager.getTheme()) {
        this.loadSiteType();
      }
    },
  }
};
</script>

<style lang="scss">
@import "./styles/fonts.scss";
@import "./styles/variables.scss";

.g-recaptcha {
  display: inline-block;
}

.captcha-container {
  text-align: center;
  min-width: 305px;
  display: block;
  margin-bottom: 1em;

  .error-message {
    font-size: 0.75em;
    margin: 0;
    color: #f57f6c;
  }

  & > div {
    text-align: center;

    & > div {
      display: inline-block;
    }
  }
}

body {
  background-color: var(--pallete_dark_color);
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

.container {
  max-width: 1280px;
  display: block;
  margin: auto;
}

main.content {
  min-height: 500px;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--pallete_dark_text_color);
}

#app, #app button, #app input, #app textarea, #app select {
  font-family: "San-Francisco", "poppins", "d-din", "Raleway", sans-serif;
}

* {
  box-sizing: border-box;
}

.form-group {
  text-align: left;
  margin-bottom: 1em;

  &.error {
    .form-control {
      border-bottom: 1px solid var(--pallete_error_color);

      &:focus {
        border-bottom: 1px solid var(--pallete_error_color);
      }
    }

    label {
      color: var(--pallete_error_color);
    }
  }

  .input-group {
    display: block;

    .form-control {
      &:not(:last-child) {
        margin-right: 0.5em;
      }
    }
  }

  .error-message {
    font-size: 0.75em;
    margin: 0;
    color: var(--pallete_error_color);
  }
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5em;
  border: none;
  background-color: var(--pallete_clear_color);

  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
  }
}

button,
.btn {
  background-color: var(--pallete_secondary_color);
  transition: background-color 1s ease;
  border: none;
  padding: 0.5em;

  &:focus {
    border: none;
    box-shadow: none;
    outline: none;
  }

  &:hover {
    // background-color: var(--pallete_secondary_color-darken-25);
    filter: brightness(1.25);
  }
}

table.table {
  display: table;
  width: 100%;
  border-spacing: 0;
  margin-bottom: 1rem;

  thead {
    tr {
      background-color: rgba(125, 125, 125, 0.5);

      th {
        padding: 0.75em;
      }
    }
  }

  tbody {
    tr {
      td {
        border-bottom: 1px solid var(--pallete_secondary_color);

        padding: 0.75em;
      }
    }
  }
}

.loadable {
  position: relative;

  .loader-wrapper {
    display: none;
    position: absolute;
    top: calc(50% - 50px);
    left: calc(50% - 25px);
  }

  &:after {
    position: absolute;
    display: block;
    visibility: hidden;
    opacity: 0;
    content: "";
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    // background: rgba(255, 255, 255, 0.7);
    transition: all 0.2s ease;
    z-index: 2;
  }

  &.loading {
    &:after {
      visibility: visible;
      opacity: 1;
    }

    .loader-wrapper {
      display: block;
    }
  }
}

.failable {
  position: relative;

  .failed-wrapper {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  &:after {
    position: absolute;
    display: block;
    visibility: hidden;
    opacity: 0;
    content: "";
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.35);
    transition: all 0.2s ease;
    z-index: 0;
  }

  &.failed {
    &:after {
      visibility: visible;
      opacity: 1;
    }

    .failed-wrapper {
      display: block;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
}

button {
  cursor: pointer;
}

.btn.main {
  &.active {
    background-image: url("/img/backgrounds/button-webstar.png");
    color: var(--pallete_over_main_text_color);
  }
  
  &:hover {
    background-image: linear-gradient(
      to left,
      var(--pallete_degrade_start_color),
      var(--pallete_degrade_finish_color)
      );
    color: var(--pallete_over_main_text_color);
  }
  
  transition: background-color 0.5s ease;
  font-weight: bold;
  color: var(--pallete_main_color);
  background-color: unset;

  border: 1px solid var(--pallete_main_color);
}

.main-btn {
  background-color: var(--pallete_main_color);
  transition: background-color 0.5s ease;
  color: var(--pallete_over_main_text_color);
  font-weight: bold;
  font-size: 0.9em;
  padding: 1em;

  &:hover {
    // background-color: var(--pallete_main_color-darken-10);
    filter: brightness(1.1);
  }
}

.dark {
  background-color: var(--pallete_over_main_text_color);
  color: var(--pallete_clear_text_color);

  section {
    & > h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      &.title {
        color: var(--pallete_clear_text_color);
      }
    }
  }
}

section {
  &:not(:last-child) {
    margin-bottom: 30px;
  }

  & > h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    &.title {
      border-top: 10px solid var(--pallete_main_color);
      color: var(--pallete_clear_text_color);
      padding: 0.33em;
      font-size: 1.4em;
      text-align: left;
      margin: 0;
      text-transform: uppercase;
      display: inline-block;
    }
  }

  @media (max-width: 768px) {
    margin-bottom: 50px;
    word-break: break-word;
  }
}

@keyframes glow {
  from {
    opacity: 0.75;
  }
  to {
    opacity: 0.35;
  }
}

.placeholder {
  animation: glow 0.5s ease-in alternate infinite;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
